// extracted by mini-css-extract-plugin
module.exports = {"galery_main":"gallery_galery_main__1QZ-C","imageWrapper":"gallery_imageWrapper__14Ws7","hidden":"gallery_hidden__3eqo5"};